import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Sprout, LogOut, User } from "lucide-react";
import { publicFileUrl } from "@/lib/api";

export default function Header({ logoFileId, siteName }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[#FAF8F5]/90 border-b border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/infaq" className="flex items-center gap-3" data-testid="header-logo-link">
          {logoFileId ? (
            <img src={publicFileUrl(logoFileId)} alt="Logo" className="h-10 w-10 rounded-full object-cover border border-[#C59B27]/40" />
          ) : (
            <div className="h-10 w-10 rounded-full bg-[#1B4D3E] flex items-center justify-center text-[#C59B27]">
              <Sprout size={20} />
            </div>
          )}
          <div className="leading-tight">
            <div className="font-bold text-sm sm:text-base text-[#1B4D3E]" data-testid="header-site-name">{siteName || "INFAK KHAIRUL FALAH"}</div>
            <div className="text-xs text-[#64748B] hidden sm:block">Gerakan Transparan & Sukarela</div>
          </div>
        </Link>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 px-3 py-2 rounded-full bg-[#EAF2EF] text-[#1B4D3E] text-sm" data-testid="header-user-badge">
                <User size={14} />
                <span className="font-medium">{user.name}</span>
                <span className="text-xs opacity-70">({user.role === "admin" ? "Bendahara" : "PJ"})</span>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={() => { logout(); nav("/infaq"); }}
                data-testid="header-logout-btn"
                className="border-[#1B4D3E] text-[#1B4D3E]"
              >
                <LogOut size={14} className="mr-1" /> Keluar
              </Button>
            </>
          ) : (
            <Button
              size="sm"
              className="bg-[#1B4D3E] hover:bg-[#143E32] text-white"
              onClick={() => nav("/infaq/login")}
              data-testid="header-login-btn"
            >
              Masuk Pengurus
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
